import { AutogenModelBrkQualProfile, AutogenRowBrkQualProfile } from "./autogen/AutogenModelBrkQualProfile";

export class ModelBrkQualProfile extends AutogenModelBrkQualProfile<RowBrkQualProfile> {
    constructor() {
        super(RowBrkQualProfile);
    }
}

export class RowBrkQualProfile extends AutogenRowBrkQualProfile {
}